import mutations from './treatmentStatisticMedio.mutations'
import actions from './treatmentStatisticMedio.actions'
import getters from './treatmentStatisticMedio.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
